import { render, staticRenderFns } from "./exames-bloqueados.vue?vue&type=template&id=96d94a7a&scoped=true&"
import script from "./exames-bloqueados.vue?vue&type=script&lang=js&"
export * from "./exames-bloqueados.vue?vue&type=script&lang=js&"
import style0 from "./exames-bloqueados.vue?vue&type=style&index=0&id=96d94a7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d94a7a",
  null
  
)

export default component.exports